import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=2addbd09&scoped=true"
import script from "./DynamicList.vue?vue&type=script&lang=js"
export * from "./DynamicList.vue?vue&type=script&lang=js"
import style0 from "./DynamicList.vue?vue&type=style&index=0&id=2addbd09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addbd09",
  null
  
)

export default component.exports